import React, { FC } from 'react';
import { Lawyer } from '../entity.types';
import { PopoverFactoryRenderer } from '../../components/popovers/PopoverFactoryRenderer';
import { LawyerPopover } from '../../lawyer/popover/LawyerPopover';
import {
  EntityListItem,
  EntityListIcon,
  EntityListGroup,
  EntityListSubtitleBlock,
} from './components/EntityListComponents';
import { EntityListLinkTitle } from './components/title/EntitlyListLinkTitle';

type Props = {
  lawyers: Array<Lawyer>;
  source: string;
  getEntityTitle: Function;
  getEntitySubtitle: Function;
  fromModal?: boolean;
};

export const LawyerList: FC<Props> = ({
  getEntityTitle,
  getEntitySubtitle,
  source,
  lawyers,
  fromModal = false,
}) => {
  const displayPopover = (element: HTMLElement) => {
    const lawyerId = element.getAttribute('data-lawyer');
    if (lawyerId) {
      return <LawyerPopover source={`${source}_popover`} lawyerId={lawyerId} />;
    }
  };

  return (
    <PopoverFactoryRenderer
      renderTemplate={displayPopover}
      isPopoverInsideModal={fromModal}
    >
      {lawyers.map((lawyer) => (
        <EntityListItem key={lawyer.url}>
          <EntityListIcon
            src={`/img/icons/entities/${
              lawyer.isVerified ? 'lawyer-verified' : 'lawyer'
            }.svg`}
            alt="lawyer-icon"
          />
          <EntityListGroup>
            <EntityListLinkTitle
              source={source}
              entityId={lawyer.lawyerId}
              entityUrl={lawyer.url}
              entityName={getEntityTitle(lawyer)}
            />
            <br />
            <EntityListSubtitleBlock>
              {getEntitySubtitle(lawyer)}
            </EntityListSubtitleBlock>
          </EntityListGroup>
        </EntityListItem>
      ))}
    </PopoverFactoryRenderer>
  );
};
